import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Component from './ShopAdoptables';
import Component_profile_shop from './ShopAdoptables.profile_shop';

export default withFeatureBranch({
  profile_shop: Component_profile_shop,
})(Component);
